module.exports = __webpack_public_path__ + "static/media/usd.06bb0185.png";